import "chart.js";
import Tooltip from "bootstrap/js/dist/tooltip";
import Collapse from "bootstrap/js/dist/collapse";
import Dropdown from "bootstrap/js/dist/dropdown";
import Modal from "bootstrap/js/dist/modal";
import Chart from 'chart.js/auto';
import {nl} from "date-fns/locale";
import "chartjs-adapter-date-fns";
import ChartDataLabels from 'chartjs-plugin-datalabels';

// charts
Chart.register(ChartDataLabels);
// Change default options for ALL charts
Chart.defaults.set('plugins.datalabels', {
  display: false,
});
window.Chart = Chart;
window.collapse = Collapse;

/**
 * Landrick theme menu handling
 */
window.toggleMenu = function () {
  document.getElementById('isToggle').classList.toggle('open');
  let isOpen = document.getElementById('navigation')
  if (isOpen.style.display === "block") {
    isOpen.style.display = "none";
  } else {
    isOpen.style.display = "block";
  }
};

// highlight active nav item
function activeNavItem() {
  let navigation = document.getElementById('navigation')
  let navItems = navigation.getElementsByClassName('nav-link');

  let matchingItem = null;
  for (let i = 0; i < navItems.length; i++) {
    let item = navItems[i];
    if (item.href === window.location.href) {
      matchingItem = item;
    } else {
      item.classList.remove('active');
    }
  }

  if (matchingItem) {
    matchingItem.classList.add('active');
  }
}

function windowScroll() {
  const navbar = document.getElementById("topnav");
  if(navbar!=null){
    if (
        document.body.scrollTop >= 50 ||
        document.documentElement.scrollTop >= 50
    ) {
      navbar.classList.add("nav-sticky");
    } else {
      navbar.classList.remove("nav-sticky");
    }
  }
}

window.addEventListener('scroll', (ev) => {
  ev.preventDefault();
  windowScroll();
})


// form handling
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function setupDecimalInputs() {
  const decimalInputs = document.querySelectorAll('.decimal-input');
  if(decimalInputs) {
    decimalInputs.forEach(el => {
      const handleInput = function() {
        // Replace comma with period
        el.value = el.value.replace(/,/g, '.');
        // Remove invalid characters
        el.value = el.value.replace(/[^0-9.-]/g, '');
      };
      
      if ('onbeforeinput' in el) {
        el.addEventListener('beforeinput', function(event) {
          if (event.data === ',') {
            event.preventDefault();
            const start = el.selectionStart;
            const end = el.selectionEnd;
            el.value = el.value.substring(0, start) + '.' + el.value.substring(end);
            el.setSelectionRange(start + 1, start + 1);
          }
          if (event.data && /[^0-9.,-]/.test(event.data)) {
            event.preventDefault();
          }
        });
      } else {
        el.addEventListener('input', handleInput);
      }
      
      if (!isIOS()) {
        el.setAttribute('inputmode', 'decimal');
      } else {
        el.removeAttribute('inputmode');
      }
    });

    //
    // // fallback to update input data before submit
    // let formElement = document.querySelector('form');
    // if(formElement != null) {
    //   formElement.addEventListener('submit', function(event) {
    //     const decimalInputs = document.querySelectorAll('.decimal-input');
    //     if(decimalInputs) {
    //       decimalInputs.forEach(input => {
    //         // Clean the input value before form submission
    //         input.value = input.value.replace(/[^0-9.,-]/g, '').replace(/,/g, '.');
    //       });
    //     }
    //   });
    // }
  }
}

window.onload = function loader() {
  activeNavItem();

  // render charts
  if(typeof chartConfigurations !== 'undefined') {
    for (let i = 0; i < chartConfigurations.length; i++) {
      const config = chartConfigurations[i];
      if (typeof config.configuration.options === 'undefined') {
        config.configuration.options = {};
      }

      let options = config.configuration.options;
      options.animation = {
        duration: 0,
      }
      options.responsive = true

      // add the date locale for x time axis
      if (typeof options.scales !== 'undefined') {
        if (typeof options.scales.x !== 'undefined') {
          if (options.scales.x.type === 'time') {
            options.scales.x.adapters = {
              date: {
                locale: nl
              }
            }
          }
        }
      }
      new Chart(config.element, config.configuration);
    }
  }

  const dropdownElementList = document.querySelectorAll('.dropdown-toggle')
  const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new Dropdown(dropdownToggleEl));

  // enable tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl,{container: 'body'}));
  
  document.querySelectorAll('.collapse').forEach(collapseElement => {
    new Collapse(collapseElement, {toggle: false});
  });
  // Initialize dropdown elements
  document.querySelectorAll('.dropdown-toggle').forEach(dropdownToggleEl => {
    new Dropdown(dropdownToggleEl);
  });
  
  setupDecimalInputs();
}

// track JS errors in Plausible
try {
  window.plausible =
      window.plausible ||
      function () {
        (window.plausible.q = window.plausible.q || []).push(arguments);
      };
  
  window.addEventListener('error', (e) => {
    plausible('JavaScript Error', {
      props: {
        message: e.message,
        filename: e.filename,
        lineno: e.lineno,
        colno: e.colno,
        url: window.location.href,
      },
    });
  });
  
  window.addEventListener('unhandledrejection', function (e) {
    plausible('JavaScript Error', {
      props: {
        message:
            'Unhandled rejection (reason: ' +
            (e.reason && e.reason.stack ? e.reason.stack : e.reason) +
            ').',
        url: window.location.href,
      },
    });
  });
} catch (e) {
  /* NOOP */
}